import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

type BaseChipProps = {
  label: string;
  open?: boolean;
  dropdownIcon?: boolean;
} & BoxProps;

export default function BaseChip({
  color,
  label,
  open = false,
  dropdownIcon = true,
  ...boxProps
}: BaseChipProps) {
  return (
    <Box
      className={open ? "active" : ""}
      sx={{
        backgroundColor: "white",
        padding: "6px 20px 6px 25px",
        borderRadius: "6px",
        display: "flex",
        justifyContent: "space-between",
        gap: "10px",
        alignItems: "center",
        fontWeight: 600,
        position: "relative",
        border: "1px solid #E1E1E2",
        cursor: "pointer",
        "&.active, &:hover": {
          borderColor: color,
        },
        "&::before": {
          content: '""',
          display: "inline-block",
          width: "10px",
          top: 0,
          left: 0,
          bottom: 0,
          backgroundColor: color,
          borderRadius: "5px 0 0 5px",
          position: "absolute",
        },
        ...(dropdownIcon && { paddingRight: "10px" }),
      }}
      {...boxProps}
    >
      <span
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label}
      </span>
      {dropdownIcon && <ExpandMore fontSize="small" htmlColor="#64748B" />}
    </Box>
  );
}
